import { AuthGuard } from "./auth/auth.guard";
import { RouteGuard } from "./route/route.guard";

export const guards: any[] = 
[
    AuthGuard,
    RouteGuard
]

export * from "./auth/auth.guard";
export * from "./route/route.guard";